/**
 * Credit Block / client file relationship type keys for Gobodo Files API.
 * Used when listing and uploading client files (listFiles relationshipTypeKey, upload reltypekey).
 *
 * Four custom types are created by setup-gobodo-creditblock-file-relationships.
 * CONTAINER is a built-in relationship type and is not created by the script.
 */

import { getCustomSuffix } from './gobodoConfig';

const suffix = () => getCustomSuffix();

/** Relationship type key for ID Documents (custom). */
export function getIdDocumentsRelKey(): string {
  return `id_documents_rel${suffix()}`;
}

/** Relationship type key for Correspondence (custom). */
export function getCorrespondenceRelKey(): string {
  return `correspondence_rel${suffix()}`;
}

/** Relationship type key for Credit Report Attachments (custom). */
export function getCreditReportAttachmentsRelKey(): string {
  return `credit_report_attachments_rel${suffix()}`;
}

/** Relationship type key for Contracts (custom). */
export function getContractsRelKey(): string {
  return `contracts_rel${suffix()}`;
}

/** Built-in CONTAINER relationship type key (no setup required). */
export const CONTAINER_REL_KEY = 'CONTAINER';

/** All relationship type keys for "all files" list (four custom + built-in CONTAINER). */
export function getAllFileRelationshipTypeKeys(): string[] {
  return [
    getIdDocumentsRelKey(),
    getCorrespondenceRelKey(),
    getCreditReportAttachmentsRelKey(),
    getContractsRelKey(),
    CONTAINER_REL_KEY,
  ];
}

export type FileCategoryForRelations =
  | 'all'
  | 'identification'
  | 'reports'
  | 'correspondence'
  | 'contracts';

/** Map UI file category to single relationship type key, or null for "all". */
export function getRelationshipTypeKeyForCategory(
  fileCategory: FileCategoryForRelations
): string | null {
  switch (fileCategory) {
    case 'identification':
      return getIdDocumentsRelKey();
    case 'reports':
      return getCreditReportAttachmentsRelKey();
    case 'correspondence':
      return getCorrespondenceRelKey();
    case 'contracts':
      return getContractsRelKey();
    case 'all':
    default:
      return null;
  }
}

/** Resolve file category to list of relationship type keys for listFiles. */
export function getRelationshipTypeKeysForList(fileCategory: FileCategoryForRelations): string[] {
  const single = getRelationshipTypeKeyForCategory(fileCategory);
  return single != null ? [single] : getAllFileRelationshipTypeKeys();
}
